import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { AddButton } from "../../../../utils/Custom/Button";
import { submitSiteDelete } from "../../../../utils/commonComponent/delete";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import ListSearchSection from "../../../../utils/Custom/ListSearchSection";
import { getPermissions } from "../../../Pages/rbac/hasAccess";
import { paginationrowsPerPageOptions } from "../../../../utils/commonComponent/commonConstant";

const fields = [
  { value: "offerId", label: "Offer ID" },
  { value: "pipelineId", label: "Pipeline ID" },
  { value: "candidateName", label: "Candidate Name" },
  { value: "position", label: "Position" },
  { value: "client", label: "Client" },
  { value: "offerStatus", label: "Offer Status" },
];

const OfferJoiningList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);

  const handleEdit = (row) => navigate(`/talent-acquisition/editOffer/${row.id}`);
  const handleDelete = (row) => submitSiteDelete("talentAcqOffer", row.id);

  const [offerList, setOfferList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "candidateName");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));

  const [offerStatuses, setOfferStatuses] = useState([]);
  const [bgvStatuses, setBgvStatuses] = useState([]);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [menuRow, setMenuRow] = useState(null);

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handlePaginationChange = (page, rows) => {
    setCurrentPage(page);
    setRowsPerPage(rows);
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", page);
    sessionStorage.setItem("ListRowsPerPage", rows);
  };

  const getWhereClause = (tablePrefix = "") => {
    const p = tablePrefix ? `${tablePrefix}.` : "";
    const key = searchKey.trim();
    let whereConditions = [`${p}status = 1`];

    if (searchBy && key) {
      if (searchBy === "pipelineId") {
        whereConditions.push(
          `p.pipelineId LIKE '%${key}%'`
        );
      } else if (searchBy === "offerStatus") {
        const found = offerStatuses.filter(m => m.name.toLowerCase().includes(key.toLowerCase())).map(m => m.id);
        if (found.length > 0) {
          whereConditions.push(`${p}offerStatus IN (${found.join(",")})`);
        } else {
          whereConditions.push("1 = 0");
        }
      } else if (searchBy === "bgvStatus") {
        const found = bgvStatuses.filter(m => m.name.toLowerCase().includes(key.toLowerCase())).map(m => m.id);
        if (found.length > 0) {
          whereConditions.push(`${p}bgvStatus IN (${found.join(",")})`);
        } else {
          whereConditions.push("1 = 0");
        }
      } else {
        whereConditions.push(`${p}${searchBy} LIKE '%${key}%'`);
      }
    }

    return `WHERE ${whereConditions.join(" AND ")}`;
  };

  const getDataQuery = () => {
    const whereClause = getWhereClause("o");
    const pagination =
      rowsPerPage !== -1
        ? `LIMIT ${rowsPerPage} OFFSET ${rowsPerPage * currentPage}`
        : "";
    return `SELECT o.*, p.pipelineId as pipelineCode, c.employmentType as candEmpType, m.Value as empTypeMasterName 
            FROM talentAcqOffer o 
            LEFT JOIN talentAcqPipeline p ON o.pipelineId = p.id 
            LEFT JOIN talentAcqCandidate c ON p.candId = c.id 
            LEFT JOIN talentAcquisitionMaster m ON (m.type = 2 AND (o.employmentType = m.id OR c.employmentType = m.id))
            ${whereClause} ORDER BY o.id DESC ${pagination};`;
  };

  const getCountQuery = () => {
    return `SELECT COUNT(*) AS totalRows 
            FROM talentAcqOffer o 
            LEFT JOIN talentAcqPipeline p ON o.pipelineId = p.id 
            ${getWhereClause("o")};`;
  };

  const fetchData = async () => {
    try {
      const [data, countResult, masters] = await Promise.all([
        fetchQuery(getDataQuery()),
        fetchQuery(getCountQuery()),
        fetchQuery("SELECT id, type, Value FROM talentAcquisitionMaster WHERE status != -1 AND type IN (10, 11)"),
      ]);

      const masterList = masters || [];
      const offerSts = masterList.filter((m) => m.type == 10).map((m) => ({ id: m.id, name: m.Value }));
      const bgvSts = masterList.filter((m) => m.type == 11).map((m) => ({ id: m.id, name: m.Value }));
      setOfferStatuses(offerSts);
      setBgvStatuses(bgvSts);

      const mapped = (data || []).map((row) => {
        const cFees = Number(row.contractFees) || 0;
        const cOther = Number(row.contractOtherAllow) || 0;
        const isContract = cFees > 0 || cOther > 0;
        
        let empTypeName = row.empTypeMasterName || row.employmentType || row.candEmpType || "";
        if (!empTypeName) {
          empTypeName = isContract ? "Contract" : "Payroll";
        }

        return {
          ...row,
          isContract,
          empTypeName,
          pipelineCode: row.pipelineCode || row.pipelineId || "",
          offerStatusName: offerSts.find((m) => m.id == row.offerStatus)?.Value || offerStatuses.find((m) => m.id == row.offerStatus)?.name || row.offerStatus || "",
          bgvStatusName: bgvSts.find((m) => m.id == row.bgvStatus)?.Value || bgvStatuses.find((m) => m.id == row.bgvStatus)?.name || row.bgvStatus || "",
        };
      });

      setOfferList(mapped);
      setTotalRows(countResult?.[0]?.totalRows || 0);
    } catch (error) {
      console.error("Error fetching offer data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("candidateName");
    setSearchKey("");
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched === false) {
      fetchData();
    }
  }, [searched]);

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-offer"
          to="/talent-acquisition/editOffer/0"
          label="Add Offer"
          icon={<AddIcon fontSize="small" />}
        />
      )}
      <ListSearchSection
        title="Search Offers"
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />
      <br />

      {/* Static custom table matching General IR pattern */}
      <div className="w-full border rounded-md shadow">
        <div className="overflow-y-auto h-auto max-h-[550px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 whitespace-nowrap">Sr. No.</th>
                <th className="px-4 py-3 whitespace-nowrap">Offer ID</th>
                <th className="px-4 py-3 whitespace-nowrap">Pipeline Code</th>
                <th className="px-4 py-3 whitespace-nowrap">Candidate Name</th>
                <th className="px-4 py-3 whitespace-nowrap">Position</th>
                <th className="px-4 py-3 whitespace-nowrap">Client</th>
                <th className="px-4 py-3 whitespace-nowrap">CTC Offered</th>
                <th className="px-4 py-3 whitespace-nowrap">Offer Date</th>
                <th className="px-4 py-3 whitespace-nowrap">Offer Status</th>
                <th className="px-4 py-3 whitespace-nowrap">Emp Type</th>
                <th className="px-4 py-3 whitespace-nowrap text-center">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {offerList.map((row, rowIndex) => (
                <tr key={row.id}>
                  <td className="px-4 py-3">{currentPage * rowsPerPage + rowIndex + 1}</td>
                  <td className="px-4 py-3 font-semibold text-gray-600">{row.offerId || "-"}</td>
                  <td className="px-4 py-3">{row.pipelineCode || "-"}</td>
                  <td className="px-4 py-3 text-gray-600">{row.candidateName || "-"}</td>
                  <td className="px-4 py-3">{row.position || "-"}</td>
                  <td className="px-4 py-3">{row.client || "-"}</td>
                  <td className="px-4 py-3 font-semibold">{row.ctcOffered ? Number(row.ctcOffered).toLocaleString("en-IN") : "-"}</td>
                  <td className="px-4 py-3">{row.offerDate || "-"}</td>
                  <td className="px-4 py-3">{row.offerStatusName || "-"}</td>
                  <td className="px-4 py-3">{row.empTypeName || "-"}</td>
                  <td className="px-4 py-2 text-center whitespace-nowrap">
                    <div className="flex items-center justify-center gap-2">
                      {(permissions.edit || permissions.allAccess) && (
                        <button
                          onClick={() => handleEdit(row)}
                          className="text-blue-600 hover:text-blue-800"
                        >
                          <EditIcon fontSize="small" />
                        </button>
                      )}
                      {(permissions.delete || permissions.allAccess) && (
                        <button
                          onClick={() => handleDelete(row)}
                          className="text-blue-600 hover:text-blue-800"
                        >
                          <DeleteIcon fontSize="small" />
                        </button>
                      )}
                      {(permissions.pdfDownload || permissions.allAccess) && (
                        <IconButton
                          size="small"
                          onClick={(e) => handleMenuOpen(e, row)}
                          className="text-blue-600"
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
              {offerList.length === 0 && (
                <tr>
                  <td colSpan={11} className="text-center py-4 text-gray-500">
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Menu for PDF options */}
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={handleMenuClose}
        >
          {menuRow?.isContract ? (
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(`/talent-acquisition/viewOffer/${menuRow.id}?doc=offer`);
              }}
            >
              <PictureAsPdfIcon fontSize="small" className="text-blue-600 mr-2" />
              Contract Letter
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(`/talent-acquisition/viewOffer/${menuRow.id}?doc=offer`);
              }}
            >
              <PictureAsPdfIcon fontSize="small" className="text-blue-600 mr-2" />
              Offer Letter
            </MenuItem>
          )}

          {!menuRow?.isContract && (
            <MenuItem
              onClick={() => {
                handleMenuClose();
                navigate(`/talent-acquisition/viewOffer/${menuRow.id}?doc=appointment`);
              }}
            >
              <PictureAsPdfIcon fontSize="small" className="text-blue-600 mr-2" />
              Appointment Letter
            </MenuItem>
          )}

          <MenuItem
            onClick={() => {
              handleMenuClose();
              navigate(`/talent-acquisition/viewOffer/${menuRow.id}?doc=joining`);
            }}
          >
            <PictureAsPdfIcon fontSize="small" className="text-blue-600 mr-2" />
            Joining Letter
          </MenuItem>
        </Menu>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={(e) =>
                handlePaginationChange(0, Number(e.target.value))
              }
              className="border rounded px-2 py-1 text-sm"
            >
              {paginationrowsPerPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRows === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                    (currentPage + 1) * rowsPerPage,
                    totalRows
                  )} of ${totalRows}`}
            </span>
            <button
              onClick={() => handlePaginationChange(0, rowsPerPage)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() =>
                handlePaginationChange(currentPage - 1, rowsPerPage)
              }
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() =>
                handlePaginationChange(currentPage + 1, rowsPerPage)
              }
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() =>
                handlePaginationChange(
                  Math.ceil(totalRows / rowsPerPage) - 1,
                  rowsPerPage
                )
              }
              disabled={currentPage >= Math.ceil(totalRows / rowsPerPage) - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OfferJoiningList;
